import { StateSlice } from '@core/helpers/state-slice';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';
import { createReducer, on } from '@ngrx/store';
import * as fromComparisons from '../actions/comparisons.action';

export type ComparisonsState = StateSlice<ReplacementOffer[]>;

export const initialState: ComparisonsState = {
  data: [],
  loaded: false,
  loading: false,
  error: null,
};

const comparisonsReducer = createReducer(
  initialState,
  on(fromComparisons.setComparisons, (state, { payload }) => {
    let comparisons = [...state.data];

    if (comparisons.includes(payload)) {
      comparisons = comparisons.filter((item) => item !== payload);
    } else {
      comparisons.push(payload);
    }

    return {
      ...state,
      data: comparisons,
      loading: false,
      loaded: true,
    };
  }),
  on(fromComparisons.setAllComparisons, (state, { payload }) => {
    return {
      ...state,
      data: payload,
    };
  }),
  on(fromComparisons.setDirectComparisons, (state, { payload }) => {
    return {
      ...state,
      data: [payload],
    };
  }),
  on(fromComparisons.clearComparisons, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: ComparisonsState | undefined,
  action: fromComparisons.ComparisonsActions
) {
  return comparisonsReducer(state, action);
}
